<template>
	<!-- Mirrors layout/page-header.vue spacing so there's no shift when the real header mounts.
	     Every measurement below is copied from that file (HAP-4106) — padding, the
	     gold marker's hairline+label row, the `lg:text-[5rem]` title band, the
	     `max-w-2xl` deck and the removal of the old full-width rule. If you retune
	     the header, retune this in the same commit or the page jumps on mount. -->
	<header class="w-full pt-10 md:pt-14 lg:pt-16 pb-14 md:pb-20">
		<div class="max-w-7xl mx-auto px-6 md:px-8">
			<div v-if="eyebrow" class="flex items-center gap-3">
				<Skeleton class="h-px w-8" />
				<Skeleton class="h-3 md:h-3.5 w-24 md:w-28" />
			</div>
			<Skeleton class="h-12 sm:h-14 md:h-20 lg:h-[5rem] w-2/3 max-w-md mt-3 md:mt-4" />
			<!--
			  One bar per rendered line of deck copy. A single bar under a deck
			  that wraps left the resources skeleton 38px short and the page
			  dropped on mount; `subtitleLines` lets each caller reserve what its
			  own copy actually occupies at that breakpoint. Bar heights track the
			  header's `text-base md:text-lg` + `leading-relaxed` line box.
			-->
			<div v-if="subtitle" class="mt-4 md:mt-5 w-full max-w-2xl">
				<Skeleton
					v-for="line in subtitleLines"
					:key="line"
					class="h-4 md:h-5"
					:class="[line > 1 ? 'mt-[6px] md:mt-[9px]' : '', line === subtitleLines && subtitleLines > 1 ? 'w-2/3' : 'w-full']"
				/>
			</div>
			<!-- Measured, not guessed: the real input is 53px at md (py-3 around a
			     20px line) and 48px below it. `h-7` reserved 28px and left the
			     events header 25px taller than its own skeleton. -->
			<Skeleton v-if="search" class="h-12 md:h-[53px] w-full max-w-md mt-8 md:mt-10" />
		</div>
	</header>
</template>

<script>
import Skeleton from '../skeleton.vue'

export default {
	name: 'PageHeaderSkeleton',
	components: { Skeleton },
	props: {
		eyebrow: { type: Boolean, default: true },
		subtitle: { type: Boolean, default: true },
		// How many lines the caller's subtitle wraps to at desktop width. Count
		// it against the header's `max-w-2xl`, not the raw string length.
		subtitleLines: { type: Number, default: 1 },
		search: { type: Boolean, default: false },
	},
}
</script>
